export const Unit = {
  KWH: "kWh",
  MWH: "MWh",
}


// WEBPACK FOOTER //
// ./src/enums/Unit.js